import React from 'react';
import { Box, Typography, IconButton } from 'minimal-ui';
import { Iconify } from 'minimal-ui';
import { background } from 'src/theme';
import { red } from '@mui/material/colors';

const DrawerHeader = ({ onClose }) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 1,
            borderBottom: '1px solid #E0E0E0',
            flexShrink: 0
        }}>
            <Box display="flex" alignItems="center" gap={2}>
                <IconButton onClick={onClose}>
                    <Iconify icon="solar:arrow-left-linear" width={28} height={28} sx={{ backgroundColor: '#ff9090', color: 'white', borderRadius: '50%', padding: '4px' }} />
                </IconButton>
                <Typography variant="h6" fontWeight={600}>
                   Back to Promotion
                </Typography>
            </Box>
        </Box>
    );
};

export default DrawerHeader;

